import { TokenHandler } from './token.handler';
import { map, switchMap } from 'rxjs/operators';
import { isTokenExpired } from './is-token-expired';
import { Observable, of as observableOf, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { accountService } from '../shop/shop-context';
import { AccountService } from '../account/account.service';
export interface JwtConfig {
	headerName: string;
	authScheme: string;
	whitelistedDomains: string[];
	skipWhenExpired: boolean;
}
export class JwtInterceptor {
	private _config: JwtConfig;
	private _environmentUrl: string;
	private _language = 'de-CH';
	private authService: AuthService;
	private accountService: AccountService;

	constructor() {
		this.authService = new AuthService();
		this.accountService = new AccountService();
		this.init();
		this._environmentUrl = window.location.origin || window.location.protocol + '//' + window.location.hostname;
	}

	private init() {
		this._config = {
			headerName: 'Authorization',
			authScheme: 'Bearer ',
			skipWhenExpired: true,
			whitelistedDomains: [this._environmentUrl]
		};
		const dataLanguage = document.body.getAttribute('data-language-long');
		if (dataLanguage && dataLanguage.length > 0) {
			this._language = dataLanguage;
		}
	}
	private getHost(href: string) {
		/* if (window.URL) { not supported by IE :(
			return new URL(href).host;
		}*/
		const match: RegExpMatchArray = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);

		return match[2];
	}

	private isWhitelistedDomain(url: string): boolean {
		const host: string = this.getHost(url);

		return (
			[this._environmentUrl, 'http://ggplus.local', 'http://172.25.99.109']
				.map(o => this.getHost(o).toLowerCase())
				.indexOf(host.toLowerCase()) > -1
		);
	}
	intercept(url: string): Observable<Headers> {
		const headers = new Headers();
		headers.append('Accept', 'application/json');
		headers.append('Content-Type', 'application/json');
		headers.append('accept-language', this._language);

		if (url.indexOf('/umbraco/surface') > -1) {
			headers.append('X-Requested-With', 'XMLHttpRequest');
		}

		let skipIssuingToken = false;
		skipIssuingToken =
			url.indexOf('/oauth/token') > -1 ||
			url.indexOf('/sign-up/empty') > -1 ||
			url.indexOf('/umbraco/surface') > -1 ||
			url.indexOf('/account/getGuestUser') > -1;

		if (skipIssuingToken) {
			return observableOf(headers);
		} else {
			const tokenHandler = new TokenHandler();
			return tokenHandler.get().pipe(
				switchMap(token => {
					if (token) {
						return of(token);
					} else {
						return this.accountService.getGuestUserAuth().pipe(
							switchMap(request => {
								return this.authService.authenticate(request);
							}),
							switchMap(() => tokenHandler.get())
						);
					}
				}),
				map(token => {
					const tokenIsExpired = isTokenExpired(token);
					if (tokenIsExpired && this._config.skipWhenExpired) {
						//don't change headers so it will throw an error
					} else if (token && this.isWhitelistedDomain(url)) {
						headers.append(this._config.headerName, `${this._config.authScheme}${token.access_token}`);
					}
					return headers;
				})
			);
		}
	}
}
